import { companyURL } from '../endpoints';
import PromiseCache from '../utils/promise-cache';
import FetchWithAuth from '../utils/fetch-with-auth';
const CompanySDK = require('@nackle/company-sdk');
function CompanyService(authState) {
  const fetch = new FetchWithAuth(authState);
  const cache = new PromiseCache(authState);
  const companySdk = CompanySDK(companyURL, fetch);
  async function listCompanies() {
    return await cache('listCompanies', async () => {
      const data = await companySdk.getCompanies();
      return data.companyList.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
    })();
  }
  async function getCompany(companyId) {
    return await cache('getCompany', async () => {
      const company = await companySdk.getCompany(companyId);
      return company;
    })();
  }
  async function listCountries(companyId) {
    return await cache(`listCountries:${companyId}`, async () => {
      const company = await getCompany(companyId);
      if (!company) {
        return null;
      }
      return company.countryList.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
    })();
  }
  return {
    listCompanies,
    getCompany,
    listCountries
  };
}
export default CompanyService;
//# sourceMappingURL=company.js.map